import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { WHATSAPP_URL } from '../utils/whatsapp';

function WhatsAppFloat() {
  return (
    <a
      className="whatsapp-float"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <SafeIcon icon={FaWhatsapp} />
    </a>
  );
}

export default WhatsAppFloat;
